import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {
    ReportVoyagePointDataLazy
} from "@containers/reports/readyReports/reportVoyagePointData/ReportVoyagePointData.lazy";

const ReportVoyagePointDataPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ReportVoyagePointDataLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ReportVoyagePointDataPage;